module.exports = __webpack_public_path__ + "img/horangit_1.67435140.png";